var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlluNoList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 108,
    viewBox: "0 0 353 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14869_255817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9641 44H10.7161C9.95609 44 9.34009 44.6167 9.34009 45.3724V66.6276C9.34009 67.3833 9.95609 68 10.7161 68H31.9641C32.7241 68 33.3401 67.3833 33.3401 66.6276V45.3724C33.3401 44.6167 32.7241 44 31.9641 44Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.142 44H97.8941C97.1341 44 96.5181 44.6167 96.5181 45.3724V66.6276C96.5181 67.3833 97.1341 68 97.8941 68H119.142C119.902 68 120.518 67.3833 120.518 66.6276V45.3724C120.518 44.6167 119.902 44 119.142 44Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5534 44H54.3054C53.5454 44 52.9294 44.6167 52.9294 45.3724V66.6276C52.9294 67.3833 53.5454 68 54.3054 68H75.5534C76.3134 68 76.9294 67.3833 76.9294 66.6276V45.3724C76.9294 44.6167 76.3134 44 75.5534 44Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 60H0V108H132V60Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.624 48H173.376C172.616 48 172 48.6167 172 49.3724V70.6276C172 71.3833 172.616 72 173.376 72H194.624C195.384 72 196 71.3833 196 70.6276V49.3724C196 48.6167 195.384 48 194.624 48Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.214 48H216.966C216.206 48 215.59 48.6167 215.59 49.3724V70.6276C215.59 71.3833 216.206 72 216.966 72H238.214C238.974 72 239.59 71.3833 239.59 70.6276V49.3724C239.59 48.6167 238.974 48 238.214 48Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 60.168H163V108.168H249V60.168Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.624 48H276.376C275.616 48 275 48.6167 275 49.3724V70.6276C275 71.3833 275.616 72 276.376 72H297.624C298.384 72 299 71.3833 299 70.6276V49.3724C299 48.6167 298.384 48 297.624 48Z",
    fill: "#FF849A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.214 48H319.966C319.206 48 318.59 48.6167 318.59 49.3724V70.6276C318.59 71.3833 319.206 72 319.966 72H341.214C341.974 72 342.59 71.3833 342.59 70.6276V49.3724C342.59 48.6167 341.974 48 341.214 48Z",
    fill: "#FF849A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 60H265V108H353V60Z",
    fill: "#FFB7C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0356 0H56.7876C56.0276 0 55.4116 0.616721 55.4116 1.37242V22.6276C55.4116 23.3833 56.0276 24 56.7876 24H78.0356C78.7956 24 79.4116 23.3833 79.4116 22.6276V1.37242C79.4116 0.616721 78.7956 0 78.0356 0Z",
    fill: "#208FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.625 0H100.377C99.617 0 99.001 0.616721 99.001 1.37242V22.6276C99.001 23.3833 99.617 24 100.377 24H121.625C122.385 24 123.001 23.3833 123.001 22.6276V1.37242C123.001 0.616721 122.385 0 121.625 0Z",
    fill: "#208FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 12.4883H46V60.4883H132V12.4883Z",
    fill: "#52A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.624 48H96.376C95.616 48 95 48.6167 95 49.3724V70.6276C95 71.3833 95.616 72 96.376 72H117.624C118.384 72 119 71.3833 119 70.6276V49.3724C119 48.6167 118.384 48 117.624 48Z",
    fill: "#208FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.213 48H139.965C139.205 48 138.589 48.6167 138.589 49.3724V70.6276C138.589 71.3833 139.205 72 139.965 72H161.213C161.973 72 162.589 71.3833 162.589 70.6276V49.3724C162.589 48.6167 161.973 48 161.213 48Z",
    fill: "#208FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 60H86V108H172V60Z",
    fill: "#52A9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14869_255817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 353,
    height: 108,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluNoList);
export default __webpack_public_path__ + "static/media/illu_no_list.1b3c301a.svg";
export { ForwardRef as ReactComponent };